import type { SearchBarWidgetAttribute, SearchBarWidgetProps } from './types';

export const DEFAULT_SEARCH_BAR_WIDGET_PROPS: SearchBarWidgetProps = {};

export const OBSERVED_SEARCH_BAR_WIDGET_ATTRIBUTES: SearchBarWidgetAttribute[] = [
  'suggest-url',
  'results-url',
  'results-url-suffix',
  'placeholder',
  'min-length',
  'debounce-ms',
  'max-results',
];

function readNumberAttribute(element: HTMLElement, name: string): number | undefined {
  const value = element.getAttribute(name);
  if (value === null) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function readSearchBarWidgetProps(element: HTMLElement): SearchBarWidgetProps {
  return {
    suggestUrl: element.getAttribute('suggest-url') ?? undefined,
    resultsUrl: element.getAttribute('results-url') ?? undefined,
    resultsUrlSuffix: element.getAttribute('results-url-suffix') ?? undefined,
    placeholder: element.getAttribute('placeholder') ?? undefined,
    minLength: readNumberAttribute(element, 'min-length'),
    debounceMs: readNumberAttribute(element, 'debounce-ms'),
    maxResults: readNumberAttribute(element, 'max-results'),
  };
}
